import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <div className="prose max-w-none">
        <p className="mb-4"><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-3">Information We Collect</h2>
        <p className="mb-4">
          When you use Google Sign-In on our platform, we collect:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Your name and email address from your Google account</li>
          <li>Your profile picture (if available)</li>
          <li>Basic account information to create your user profile</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-3">How We Use Your Information</h2>
        <p className="mb-4">We use the information collected to:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Create and manage your account</li>
          <li>Process your orders and transactions</li>
          <li>Provide customer support</li>
          <li>Send order confirmations and updates</li>
          <li>Improve our services</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Google Sign-In</h2>
        <p className="mb-4">
          We use Google Sign-In to provide a secure and convenient way to access your account. 
          We only request access to your basic profile information (name, email, profile picture) 
          and do not access any other Google services or data.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Data Security</h2>
        <p className="mb-4">
          We implement appropriate security measures to protect your personal information against 
          unauthorized access, alteration, disclosure, or destruction.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p className="mb-4">
          Email: seb7at.kw@gmail.com<br />
          Address: Kuwait
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
